module.exports = __webpack_public_path__ + "img/shopimind-logo-white.34f87702.svg";